import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, ArrowRight, Info, PhoneCall } from "lucide-react";
import { DEMO_CREDENTIALS } from "./demoData";
import { inputCls } from "./ui";

export default function DemoLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState(DEMO_CREDENTIALS.email);
  const [password, setPassword] = useState(DEMO_CREDENTIALS.password);
  const [error, setError] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (email.trim().toLowerCase() !== DEMO_CREDENTIALS.email || password !== DEMO_CREDENTIALS.password) {
      setError("Use the demo account shown below to sign in.");
      return;
    }
    sessionStorage.setItem("dmm_publisher_demo", "1");
    nav("/publisher-demo/panel");
  };

  return (
    <div className="min-h-screen bg-[#070a0f] text-slate-100 font-['Inter',sans-serif] grid lg:grid-cols-2" data-testid="demo-login-page">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-gradient-to-br from-blue-950/60 via-[#0a0f1a] to-purple-950/40 border-r border-slate-800">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-600 to-purple-600 flex items-center justify-center"><PhoneCall className="w-5 h-5 text-white" /></div>
          <div>
            <p className="font-semibold text-white">Digital Master Media</p>
            <p className="text-[10px] tracking-[0.2em] text-slate-400">PUBLISHER PANEL</p>
          </div>
        </div>
        <div>
          <h2 className="font-['Poppins'] text-4xl font-bold leading-tight text-white">Your calls. Your earnings.<br /><span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">All in one place.</span></h2>
          <p className="mt-4 text-slate-400 max-w-md">Track live offers, qualified calls, CallIntell™ quality score and weekly payouts in real time.</p>
        </div>
        <p className="text-xs text-slate-500">© Digital Master Media LLC</p>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="demo-login-form">
          <h1 className="font-['Poppins'] text-3xl font-bold text-white">Publisher Login</h1>
          <p className="mt-2 text-sm text-slate-400">Sign in to your publisher panel.</p>
          <label className="block mt-8 text-xs font-semibold text-slate-400 mb-1.5">Email</label>
          <div className="relative">
            <Mail className="w-4 h-4 text-slate-500 absolute left-3.5 top-3" />
            <input className={`${inputCls} pl-10`} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="demo-login-email" />
          </div>
          <label className="block mt-4 text-xs font-semibold text-slate-400 mb-1.5">Password</label>
          <div className="relative">
            <Lock className="w-4 h-4 text-slate-500 absolute left-3.5 top-3" />
            <input type="password" className={`${inputCls} pl-10`} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="demo-login-password" />
          </div>
          {error && <p className="mt-3 text-sm text-red-400" data-testid="demo-login-error">{error}</p>}
          <button type="submit" data-testid="demo-login-submit" className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white font-semibold py-3 rounded-xl transition-colors">
            Sign In <ArrowRight className="w-4 h-4" />
          </button>
          <div className="mt-6 rounded-xl border border-blue-500/30 bg-blue-500/5 p-4 text-xs text-slate-300 flex gap-3" data-testid="demo-login-hint">
            <Info className="w-4 h-4 text-blue-400 flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-semibold text-white">Demo account</p>
              <p className="mt-1">Email: {DEMO_CREDENTIALS.email}<br />Password: {DEMO_CREDENTIALS.password}</p>
              <p className="mt-1 text-slate-500">All data inside is sample data.</p>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
